import { FileText } from "lucide-react";
import { useTranslation } from "react-i18next";

import { TextPrimaryButton } from "src/components/Default/LekUI/Button";

interface ImportedFileCardProps {
	fileName: string;
	meta: string;
	onChange: () => void;
	imageSrc?: string;
}

export const ImportedFileCard = ({
	fileName,
	meta,
	onChange,
	imageSrc,
}: ImportedFileCardProps) => {
	const { t } = useTranslation();

	return (
		<div className="flex items-center gap-12 border-medium-grey border-radius-12 bg-white p-12">
			{imageSrc ? (
				<img src={imageSrc} alt={fileName} className="file-thumbnail" />
			) : (
				<FileText className="icon-big icon-primary flex-shrink-0" />
			)}
			<div className="flex flex-col gap-4 flex-1 min-w-0">
				<span className="size-16 font-semibold text-ellipsis-1">
					{fileName}
				</span>
				<span className="size-14-light text-grey">{meta}</span>
			</div>
			<TextPrimaryButton onClick={onChange} data-test-id="import-change-file">
				{t("flashcardsImport.changeFile", "Zmień plik")}
			</TextPrimaryButton>
		</div>
	);
};
